import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import BackArrow2 from "../../components/BackArrow2";
import Loader from "../../components/SharedLayouts/Loader";
import StockForm, {
  booleanOptions,
  currencyStockOptions,
  trendOptions,
} from "./StockForm";
import { buildStockPayload } from "./buildStockFormData";
import { getStock } from "../../store/actions/stocks/getStock";
import { updateStock } from "../../store/actions/stocks/updateStock";
import { createStockSchema } from "../../Helper/validationSchemas";

const toOption = (options, value) =>
  options.find((opt) => opt.value === value) || "";

const toBooleanOption = (value) =>
  booleanOptions.find((opt) => opt.value === (value ? 1 : 0)) ||
  booleanOptions[0];

function EditStock() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  const stock = useSelector((state) => state?.stocks?.stock);
  const fetchPending =
    useSelector((state) => state?.stocks?.getStockPending) || false;
  const loading = useSelector((state) => state?.stocks?.updatePending) || false;

  useEffect(() => {
    dispatch(getStock(id));
  }, [dispatch, id]);

  const form = useFormik({
    enableReinitialize: true,
    initialValues: {
      symbol: stock?.symbol || "",
      name: stock?.name || "",
      currency:
        toOption(currencyStockOptions, stock?.currency) ||
        currencyStockOptions[0],
      current_price: stock?.current_price ?? "",
      available_volume: stock?.available_volume ?? "",
      percent_change: stock?.percent_change ?? 0,
      trend: toOption(trendOptions, stock?.trend) || trendOptions[2],
      description: stock?.description || "",
      sector: stock?.sector || "",
      logo_url: stock?.logo_url || "",
      min_volume: stock?.min_volume ?? 1,
      // min_price: stock?.min_price ?? 0,
      // max_price: stock?.max_price ?? 0,
      is_active: toBooleanOption(stock?.is_active),
      is_shariah_compliant: toBooleanOption(stock?.is_shariah_compliant),
    },
    validationSchema: createStockSchema,
    onSubmit: (values, { setSubmitting }) => {
      const data = buildStockPayload(values);
      dispatch(updateStock({ id, data, navigate, setSubmitting }));
    },
  });

  return (
    <DashboardLayout>
      <div className="px-2 lg:px-8">
        <div className="flex items-center mb-8 flex-row md:items-center">
          <Link to={"/dashboard"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-2" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
          <Link
            to="/stocks"
            className="font-semibold text-[#475467] text-base flex"
          >
            Stocks
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 md:mr-2" />
          <span className="font-semibold text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md">
            Edit
          </span>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center mt-8 mb-4 md:mb-6">
          <h1 className="font-semibold text-xl md:text-2xl w-full">
            Edit Stock
          </h1>
        </div>
        <BackArrow2 mb={20} ml={0} />

        {fetchPending && !stock ? (
          <Loader />
        ) : (
          <StockForm
            form={form}
            loading={loading}
            submitLabel="Update Stock"
            logo={logo}
            setLogo={setLogo}
            logoPreview={logoPreview}
            setLogoPreview={setLogoPreview}
            existingLogoUrl={stock?.logo_url}
            onCancel={() => navigate(-1)}
          />
        )}
      </div>
    </DashboardLayout>
  );
}

export default EditStock;
